import PrimaryButton from 'core-system/Button/PrimaryButton'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import FlexContainer from 'core-system/FlexContainer'
import Radio from 'core-system/Radio'
import Text from 'core-system/Text'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  padding-top: 0.5rem;
`

const DeliveryOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.25rem;
`

const DeliveryOption = styled.div`
  cursor: pointer;
`

type InviteDelivery = 'WITH_EMAIL' | 'WITHOUT_EMAIL'

interface MyCommuterInviteProps {
  employeeId: string
  onCancel: () => void
  onInvite: (sendWelcomeEmail: boolean) => void
}

const MyCommuterInvite = React.memo((props: MyCommuterInviteProps) => {
  const { employeeId, onCancel, onInvite } = props
  const [inviteDelivery, setInviteDelivery] =
    useState<InviteDelivery>('WITH_EMAIL')

  const hasInvite = useSelector(
    (state: AppState) => state.employee.myCommuterDetails[employeeId].hasInvite
  )
  const sendWelcomeEmail = inviteDelivery === 'WITH_EMAIL'

  return (
    <>
      <Container>
        <Text variant='h5'>
          {hasInvite
            ? 'This commuter has already been invited. Send another invite?'
            : 'Invite this commuter?'}
        </Text>
        <Text variant='body1' marginTop='0.75rem'>
          {sendWelcomeEmail
            ? `They will receive ${
                hasInvite ? 'another' : 'an'
              } email inviting them to register with Fleet.`
            : 'They will be marked as invited without sending an email.'}
        </Text>
        <DeliveryOptions>
          <DeliveryOption onClick={() => setInviteDelivery('WITH_EMAIL')}>
            <Radio active={sendWelcomeEmail} label='Invite with email' />
          </DeliveryOption>
          <DeliveryOption onClick={() => setInviteDelivery('WITHOUT_EMAIL')}>
            <Radio active={!sendWelcomeEmail} label='Invite without email' />
          </DeliveryOption>
        </DeliveryOptions>
      </Container>
      <FlexContainer justifyContent='flex-end' marginTop='2rem'>
        <SecondaryButton onClick={onCancel} style={{ marginRight: '1rem' }}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={() => onInvite(sendWelcomeEmail)}>
          Invite Commuter
        </PrimaryButton>
      </FlexContainer>
    </>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  MyCommuterInvite.displayName = 'MyCommuterInvite'
}

export default MyCommuterInvite
